import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SupplierService } from 'src/app/services/supplier/supplier.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { SupplierAssociationsComponent } from '../supplier-associations.component';

@Component({
  selector: 'app-delete-customer-supplier-xref',
  templateUrl: './delete-customer-supplier-xref.component.html',
  styleUrls: ['./delete-customer-supplier-xref.component.scss']
})
export class DeleteCustomerSupplierXrefComponent implements OnInit {

  customer: any;
  customerSupplierIds: any = [];
  isLoading: boolean;
  onDeleteCustomerSupplierId = new EventEmitter();

  constructor(private modal: ModalService,
    public dialogRef: MatDialogRef<SupplierAssociationsComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private supplierService: SupplierService,
              private _flashMessageSvc: FlashMessageService) {
    this.customer = data;
    this.customerSupplierIds = data.customer_supplier_ids;
  }

  ngOnInit() {
  }


  /**
   * call unlink customer api and assign resp to this.customer
   * @param custSuppId
   */
  public deleteCustomerSupplierId(custSuppId: string) {
    this.isLoading = true
    const payload = {
      suppID: this.customer.supplier_id,
      custID: this.customer.erp_customer_id,
      custSupID: custSuppId
    }
    this.supplierService.unlinkCustomer(payload)
      .then((data) => {
        this.isLoading = false;
        this.customer = data;
        this.customerSupplierIds = this.customer.customer_supplier_ids;
        // if xref has one custSupID in array then will remove the xref record from mongo. so, it will return {count: 1}
        if(this.customer.count === 1) {
          this.onCancel();
        }
      })
      .catch(() => {
        this.isLoading = false;
        this._flashMessageSvc.updateMessage('Not able to unlink customer');
      });
  }

  // Send ComponentName and date after closing modal
  public onCancel() {
    this.modal.close({ sourceComponent: 'DELETE', data: this.customer });
  }
}

